import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { IconeDownload } from "../../IconeDownload";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";

export const Guarda = ({ dataGuarda }) => {
  const columnsGuarda = [
    {
      Header: "Tipo",
      accessor: "tipoTermoGuarda",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value.descricao}</Text>;
      },
      disableSortBy: true,
    },
    {
      Header: "Nome",
      accessor: "pessoaGuarda",
      Cell: (props) => {
        const nome = props?.value?.nome;

        return (
          <Text
            whiteSpace={{ base: "nowrap", lg: "normal" }}
            wordBreak={"break-all"}
          >
            {nome}
          </Text>
        );
      },
      disableSortBy: true,
    },
    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
      disableSortBy: true,
    },
    {
      Header: "Decisão Judicial",
      accessor: "possuiGuarda",
      Cell: (props) => {
        return (
          <span>
            {props.value ? (
              <>
                <Flex marginLeft={10}>
                  <button>
                    <IconeDownload />
                  </button>
                </Flex>
              </>
            ) : (
              ""
            )}
          </span>
        );
      },
      disableSortBy: true,
    },
  ];

  return dataGuarda && dataGuarda.length > 0 ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Guarda"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <IrmaoTable
            disableHeaderOptions={true}
            columns={columnsGuarda}
            data={dataGuarda}
            filiacoes={dataGuarda}
            guarda={true}
            isPrint={true}
          />
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Guarda"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
